module.exports = __webpack_public_path__ + "static/icon_ggbet-c6f8e33f6e377f97ce6b3fc1f3ffd7b1.png";